import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import Typography from '@finam/web-ui-kit/Typography';
import styled from 'styled-components';
import { useClassName } from '../../uiClassNames';
var RootAnchor = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  text-decoration: none;\n  cursor: pointer;\n"])));
var Link = forwardRef(function (_a, ref) {
  var className = _a.className,
      href = _a.href,
      disabled = _a.disabled,
      _a$typographyVariant = _a.typographyVariant,
      typographyVariant = _a$typographyVariant === void 0 ? 'body14' : _a$typographyVariant,
      onClick = _a.onClick,
      children = _a.children,
      otherProps = __rest(_a, ["className", "href", "disabled", "typographyVariant", "onClick", "children"]);

  var linkClassName = useClassName('link', className);
  return _jsx(RootAnchor, Object.assign({
    className: linkClassName,
    onClick: !disabled ? onClick : undefined,
    href: !onClick ? href : undefined,
    target: !onClick ? '_blank' : undefined,
    rel: !onClick ? 'noreferrer noopener' : undefined,
    ref: ref
  }, otherProps, {
    children: _jsx(Typography, Object.assign({
      as: "span",
      variant: typographyVariant,
      color: disabled ? 'disabled' : 'main'
    }, {
      children: children
    }))
  }));
});
export default memo(Link);